import React from 'react';
import {NavLink, Link} from "react-router-dom";
import help from '../../assets/images/icons/help.png';
// import card from '../../assets/images/icons/new-card.png';
import card from '../../assets/images/icons/card.png';
import helpBlue from '../../assets/images/icons/blue-help.png';
import {Helmet} from "react-helmet";
import metatags from '../static/metatags';

class Payment extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      pay_TaxVal: '',
      pay_FeeVal: '',
    }
  }
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  componentWillMount = () => {
    this.props.payment_CreateAPI();
    this.props.addMessageListener();
  }

  render() {
    return (
      <>
      <section className={`cmx-payment-page ${this.props.state.payment_overlay ? 'open-overlay':''}`}>
        <Helmet>
          <title>{metatags.commonMetatag.title}</title>
          <meta name="description" content={metatags.commonMetatag.description} />
        </Helmet>
        <aside className='head text-center pt-4'>
          <h1><span className='txt-top d-block'>Payment Details</span></h1>
        </aside>
        <section className='payment-container'>
          {/* accordion > start */}
          <section className='acc-blk'>
            <section className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading-1">
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-1" aria-expanded="true" aria-controls="collapse-1">
                    {/* Alejandro's Details */}
                    {this.props.state.loginAPI != '' ? this.props.state.loginAPI.firstname:this.props.state.firstname} Details
                  </button>
                </h2>
                <div id="collapse-1" className="accordion-collapse collapse show" aria-labelledby="heading-1" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <section className='mob-blk'>
                      <section className='fixed-position'>
                        <ul className='list-blk'>
                          <li className="name">
                            {
                              this.props.state.loginAPI != '' ? <p>{this.props.state.loginAPI.firstname}</p>:<p>{this.props.state.firstname}</p>
                            }
                          </li>
                          <li className="email">
                            {
                              this.props.state.loginAPI != '' ? <p>{this.props.state.loginAPI.email}</p>:<p>{this.props.state.signUpEmailValue}</p>
                            }
                          </li>
                          <li className="mobile">
                            {
                              this.props.state.loginAPI != '' ? <p>{this.props.state.loginAPI.phonenumber}</p>:<p>{this.props.state.signUpMobileValue}</p>
                            }
                          </li>
                        </ul>
                      </section>
                    </section>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="heading-2">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse-2" aria-expanded="true" aria-controls="collapse-2">
                    CMX Passport Plan Details
                  </button>
                </h2>
                <div id="collapse-2" className="accordion-collapse collapse" aria-labelledby="heading-2" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <section className='mob-blk'>
                      <aside className='mob-close-icon'>
                        <a onClick={this.props.payment_closeBtn} href='javascript:;' title='Close'>&nbsp;</a>
                      </aside>
                      <section className='fixed-position'>
                        <section className='plan-box'>
                          <ul>
                            <li><span className='lft'>Where</span><span className='rgt'>{this.props.state.step1_content}</span></li>
                            {
                              this.props.state.billingGetPriceObj != '' &&
                              <>
                                <li><span className='lft'>When</span><span className='rgt'>{this.props.state.billingGetPriceObj[0].monThu ? 'Monday to Thursday':'Any day of the year'} {this.props.state.billingGetPriceObj[0].monThu && <i>(Thursdays only before 6 PM)</i>}</span></li>
                                <li><span className='lft'>How often</span><span className='rgt'>{this.props.state.billingGetPriceObj[0].visits} Movies(s) Per Month</span></li>
                                <li>
                                  <span className='lft'>With whom</span>
                                  <span className='rgt'>{this.props.state.billingGetPriceObj[0].guests == '0' ? 'Myself only':`Myself + ${this.props.state.billingGetPriceObj[0].guests} guest(s)`}</span>
                                </li>
                              </>
                            }
                            
                          </ul>
                        </section>
                        
                        <section className='plan-price'>
                          <ul>
                            <li><span className='lft'>Your plan</span><span className='rgt'>${this.props.state.createAPI.priceBeforeTax}</span></li>
                            <li>
                              <span className='lft'>Taxes 
                                <span className='mob-hide-blk'> and Fees - 9% 
                                  <span className='help-icon'>
                                    <figure className='d-inline-block align-top ps-1'><img src={help} alt="Help" className="img-fluid" /></figure>
                                    {
                                      this.props.state.taxAPI != '' &&
                                      <aside className='tool'>
                                        <p>
                                          <span className='lft'>Tax</span>
                                          {
                                            this.props.state.taxAPI[0].taxpercentage == '0.000' ? 
                                              <span className='rgt'>$0.00</span>
                                            :
                                              <span className='rgt'>${this.props.state.correctedTaxValue}</span>
                                          }
                                          
                                        </p>
                                        <p>
                                          <span className='lft'>Fees</span>
                                          {
                                            this.props.state.taxAPI[0].taxpercentage == '0.000' ? 
                                              <span className='rgt'>${this.props.state.createAPI.taxValue}</span>
                                            :
                                              <span className='rgt'>${this.props.state.correctedFeeValue}</span>
                                          }
                                          
                                        </p>
                                      </aside>
                                    }
                                    
                                  </span>
                                </span>
                              </span>
                              <span className='rgt'>${this.props.state.createAPI.taxValue}</span></li>
                          </ul>
                        </section>
                        <section className='total-blk'>
                          <ul>
                            <li><span className='lft'>Total</span><span className='rgt'>${this.props.state.createAPI.value}</span></li>
                          </ul>
                        </section>
                      </section>
                    </section>
                  </div>
                </div>
              </div>
            </section>
          </section>
          {/* accordion > start */}
          
          {/* Payment info > start */}
          <section className='payment-blk'>
            <section className='card-blk'>
              <h2>Payment Information</h2>
              <aside className='crd-card'>
                <aside className='lft-card'>
                  <p>Credit Card <span>Visa, Mastercard, Amex</span></p>
                  {/* <p>Credit Card <span>Mastercard, Amex</span></p> */}
                </aside>
                <aside className='rgt-card'>
                  <figure>
                    <img src={card} alt="card" className="img-fluid" />
                  </figure>
                </aside>
              </aside>
              {/* <aside className='visa-error-blk'>
                <p>Currently, our program is not accepting VISA payments. This will be corrected soon.</p>
                <p>Accepting only U.S. zip codes</p>
              </aside> */}
              <section className='pay-form-blk'>
                <aside className='form-group'>
                  <aside className='form-inner'>
                    <input 
                      type="text" 
                      placeholder='Name on card' 
                      autoComplete="off"
                      name="paymentNameOnCard"
                      onChange={(e) => this.props.nameOnCardOnChange(e)}
                      value={this.props.state.paymentNameOnCard}
                    />
                  </aside>
                </aside>
                <section className="cd-form-blk">
                  <iframe id="paymentIframe" frameBorder="0" src={this.props.state.paymentIframeSrc}></iframe>
                </section>

                {/* <aside className='form-group'>
                  <aside className='form-inner'>
                    <input type="text" placeholder='Card number' />
                  </aside>
                </aside>
                <section className='mycvv-blk'>
                  <aside className='form-group'>
                    <aside className='form-inner'>
                      <input type="text" placeholder='MM' />
                    </aside>
                  </aside>
                  <aside className='form-group'>
                    <aside className='form-inner'>
                      <input type="text" placeholder='YY' />
                    </aside>
                  </aside>
                  <aside className='form-group'>
                    <aside className='form-inner'>
                      <input type="text" placeholder='CVV' />
                    </aside>
                  </aside>
                </section>
                <aside className='form-group'>
                  <aside className='form-inner'>
                    <input type="text" placeholder='Card holder’s name' />
                  </aside>
                </aside>
                <aside className='btm-wrap'>
                  <p>This payment method will be used as default for automatic reccuring billing</p>
                </aside> */}

              </section>
            </section>
          </section>
          {/* Payment info > end */}

          {/* <section className='mob-theatre-blk'>
            <h2>Theatre visits <span><i>*</i> - Mandatory</span></h2>
            <section className='visit-box'>
              <aside className='box'>
                <p>How many times have you gone to a movie theatre in the past year? <i>*</i></p>
                <input type="text" defaultValue="7" maxLength="1" />
              </aside>
              <aside className='box'>
                <p>Of those times how many of them were to a CMX / Cobb / CineBistro location? <i>*</i></p>
                <input type="text" defaultValue="4" maxLength="1" />
              </aside>
            </section>
          </section> */}

          {/* <section className='btm-check'>
            <aside className='form-group'>
              <input type="checkbox" id="i-agree" defaultChecked />
              <label htmlFor='i-agree'>I agree to the CMX Flex Subscription <a onClick={(e) => this.props.TandC_componentClick(e, 'payment')} className='text-decoration-underline' href='javascript:;' title='Terms &amp; Conditions'>Terms &amp; Conditions</a><span className='radio-btn'>&nbsp;</span></label>
            </aside>
          </section> */}
        </section>

        {/* Footer > start */}
        <section className='footer-price-blk'>
          <section className='content'>
            <section className='lft text-center w-100'>
              <p className='desktop'>Total Price<i>:</i>
                <span> ${this.props.state.createAPI.value} 
                  <em> {this.props.state.choosePlanName} 
                    {/* <img src={helpBlue} alt="Help" className="img-fluid" /> */}
                  </em>
                </span>
              </p>
            </section>
            {/* <section className='rgt'>
              <aside className="cmx-flex-btn-group text-end">
                <Link className='flex-btn' exact to={"/payment-success"} title='PURCHASE'><span>Purchase</span></Link>
              </aside>
            </section> */}
          </section>
        </section>
        {/* Footer > end */}

        <aside className='overlay-bg'>&nbsp;</aside>

      </section>
      
      

      </>
    )
  }
}

export default Payment;
